import * as Yup from "yup";

type IStudentDetailSchema = {
  lastName?: string;
  firstName: string;
  gender: string;
  gradeId: number;
  sectionId: number;
};

const studentSchema: Yup.ObjectSchema<IStudentDetailSchema> =
  Yup.object().shape({
    lastName: Yup.string(),
    firstName: Yup.string().required("First Name is required."),
    gender: Yup.string().required("Gender is required"),
    gradeId: Yup.number()
      .min(0, "Grade is required")
      .required("Grade is required"),
    sectionId: Yup.number()
      .min(0, "Section is required")
      .required("Section is required"),
  });

export { studentSchema };
export type { IStudentDetailSchema };
